export default "__VITE_ASSET__3898a555__"